<div class="block--content block">
    <div class="ticket">
        <ridango-page-content-wrapper>
            <rwidget-alert [assetsPath]="assetsPath$ | async"></rwidget-alert>

            <div class="intro-text">
                <h1 class="title">{{ 'BOOK_RIDE_SPECIFY_RIDE' | translate }}</h1>
                <p>{{ 'BOOK_RIDE_SPECIFY_DESCRIPTION' | translate }}</p>
            </div>

            <rwidget-product-passenger-count-selector
                [products]="products$ | async"></rwidget-product-passenger-count-selector>

            <ridango-arrow-down-separator *ngIf="products$ | async"></ridango-arrow-down-separator>

            <rwidget-purchase-medium [allowPurchaseOnlyAddedCards]="true"></rwidget-purchase-medium>

            <ridango-arrow-down-separator></ridango-arrow-down-separator>

            <rwidget-additional-information *ngIf="showAdditionalComponent"></rwidget-additional-information>

            <ridango-arrow-down-separator *ngIf="showAdditionalComponent"></ridango-arrow-down-separator>
        </ridango-page-content-wrapper>

        <!-- summary -->
        <rwidget-booking-summary
            [products]="products$ | async"
            [isValidated]="isFlowValidated"
            [loading]="loading$ | async"
            (onSubmitBookings)="submitBooking()">
        </rwidget-booking-summary>
    </div>
</div>
